import { IDropdownOption } from '@fluentui/react';
import React from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { AppContext, MenuFilters } from '../../AppInRouterContext';
import { unhash } from '../../common/constants';
import { Torneo, Club } from '../../system/SystemClient';
import { TorneoNotFound } from '../Common/TorneoNotFound';
import { TorneoContainer } from './TorneoContainer';
import BasicBlockUI from '../../components/Common/BasicBlockUI';
import { setUncaughtExceptionCaptureCallback } from 'node:process';

interface ITorneoDetailViewProps {
  appContext: AppContext;
  onChangeFilters: (criterio: string, value: string) => void;
  menuFilters: MenuFilters;

  categorias: IDropdownOption<any>[];
  temporadas: IDropdownOption<any>[];
  federaciones: IDropdownOption<any>[];
  ramas: IDropdownOption<any>[];
}

const TorneoDetailView = (props: ITorneoDetailViewProps) => {
  let { id } = useParams();

  const CLUB_TODOS: Club = { club: 'Todos los clubes', clubId: '0', clubEscudo: '' };

  const [searchParams] = useSearchParams();
  const byLink = searchParams.get('direct'); // ejemplo: ?myParam=valor
  const clubIdParam = searchParams.get('clubId'); // ejemplo: ?myParam=valor
  const clubId = Number(clubIdParam) > 0 ? clubIdParam : null;

  const [torneo, setTorneo] = React.useState<Torneo | undefined>(undefined);
  const [club, setClub] = React.useState<Club | undefined>(undefined);
  const [lastUpdate, setLastUpdate] = React.useState<any>(new Date());
  const [refresh, setRefresh] = React.useState<boolean>(false);
  const [showTorneoNotFoundDialog, setShowTorneoNotFoundDialog] = React.useState<boolean>(false);
  const [block, setBlock] = React.useState(false);

  const changeBlockUI = (shouldBlock: boolean) => {
    setBlock(shouldBlock);
  };

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });

    const getTorneo = async () => {
      try {
        if (!id) return;
        const password = props.appContext.system.getEnvironment().passphrase();
        const idUnhashed = unhash(id, password);
        const ret = await props.appContext.system.getTorneo(idUnhashed);
        if (ret !== null) {
          console.log(ret, 'ret');
          setTorneo(ret);
          setLastUpdate(new Date());
        } else {
          setShowTorneoNotFoundDialog(true);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const getClub = async () => {
      try {
        const idNum = Number(clubId);
        if (!idNum || idNum <= 0 || Number.isNaN(idNum)) {
          setClub(CLUB_TODOS);
          return;
        }
        const ret = await props.appContext.system.getClub(String(idNum));
        if (ret) setClub(ret);
      } catch (e) {
        console.log(e);
      }
    };

    // Función que coordina ambas llamadas
    const fetchData = async () => {
      changeBlockUI(true);
      try {
        await Promise.all([getTorneo(), getClub()]);
      } finally {
        changeBlockUI(false);
      }
    };

    fetchData();

    const algunPartidoEnVivo =
      torneo?.fases?.some((fase) =>
        fase.zonas?.some((zona) => zona.partidos?.some((partido) => partido.playing))
      ) ?? false;

    const intervaloTiempo = algunPartidoEnVivo ? 60000 : 300000; // 1m vs 5m
    const intervalo = setInterval(fetchData, intervaloTiempo);

    return () => clearInterval(intervalo);
  }, [refresh, clubId]);

  const navigate = useNavigate();

  return (
    <>
      <BasicBlockUI blockUI={block} />
      {torneo && (
        <TorneoContainer
          torneo={torneo}
          hideBack={!!byLink}
          lastUpdate={lastUpdate}
          refresh={refresh}
          setRefresh={setRefresh}
          hideRefresh={false}
          highlightClubId={clubId ?? undefined}
          club={club}
        ></TorneoContainer>
      )}
      <TorneoNotFound
        showTorneoNotFoundDialog={showTorneoNotFoundDialog}
        setShowTorneoNotFoundDialog={setShowTorneoNotFoundDialog}
      ></TorneoNotFound>
    </>
  );
};

export default TorneoDetailView;
